import {
  SR_API_ACTION_LEASING_MANAGER_GET_LIST_WITH_PARTNERS,
} from 'api/actionTypes';

export default async function getList({ state, apiClient }) {
  const statePath = ['leasingManagers', 'listWithPartners'];

  await apiClient.postWithState({
    action: SR_API_ACTION_LEASING_MANAGER_GET_LIST_WITH_PARTNERS,
    state: state,
    onSuccess(leasingManagers) {
      state.set(statePath, leasingManagers);
    },
  });
}
